const Jumbotron = () => {
    return (
        <section className="section-1 mt-5">
            {/* <div className="bg_image jumbotron d-flex align-items-center">
                <div className="gradient"></div>
                <div className="container-fluid content">
                    <h1 data-aos="zoom-in" data-aos-delay="300">Welcome to Dr. Ebrahimi's Web Pag</h1>
                    <h2 data-aos="zoom-in" data-aos-delay="300">Dr. Alireza Ebrahimi earned his Ph.D. in Computer Science from the Polytechnic University of New York.</h2>
                </div>
            </div> */}
        </section>
    );
}
export default Jumbotron;